import { apiRequest } from "./common";

const createFaq = async (data) => {
    const response = await apiRequest('post', '/faq', data);
    return response.data;
};

const updateFaq = async (id, data) => {
    const response = await apiRequest('put', `/faq/${id}`, data);
    return response.data;
};

const deleteFaq = async (id) => {
    const response = await apiRequest('delete', `/faq/${id}`);
    return response.data;
};

const getFaqList = async () => {
    const response = await apiRequest('get', `/faq`);
    return response.data;
};

const updateReorder = async (data) => {
 const response = await apiRequest('patch', `/faq/reorder`, data);
    return response.data;
};

export {
    createFaq,
    updateFaq,
    deleteFaq,
    getFaqList,
    updateReorder
};
